import React, { Component } from 'react';
import ReactDOM from 'react-dom';


class Timeline extends Component {

  render() {
    const {
      currentTime,
      timeBarPosition
    } = this.props;
    
    const top = {
      top: `${timeBarPosition}px`,
    }
    const marginTop = {
      top: `${timeBarPosition-200}px`,
    }
    return [ 
      <div id='timeline-onair' style={marginTop} key='timetext'></div>,
      <div className='time-bar' id='time-line' style={top}  key='timeline'>
        <div className='time-bar-text'>{currentTime}</div>
      </div>
    ];
  }
}

export default Timeline;


// WEBPACK FOOTER //
// ./src/components/timeline/index.js